(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2914,6244],{

/***/ 46118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ Carousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-smooth-horizontal-scroll/dist/index.js
var dist = __webpack_require__(36319);
// EXTERNAL MODULE: ./components/styleguide/Carousel/carousel.module.scss
var carousel_module = __webpack_require__(67227);
var carousel_module_default = /*#__PURE__*/__webpack_require__.n(carousel_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/Carousel/Carousel.tsx









var BrandsModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(535), __webpack_require__.e(1085)]).then(__webpack_require__.bind(__webpack_require__, 11085));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11085)
            ];
        }
    },
    ssr: false
});
var Carousel = function(param) {
    var children = param.children, scrollValue = param.scrollValue, moreLink = param.moreLink, moreLabel = param.moreLabel, sectionName = param.sectionName, header = param.header, onCustomButtonClick = param.onCustomButtonClick, _className = param.className, className = _className === void 0 ? "" : _className, _carouselClass = param.carouselClass, carouselClass = _carouselClass === void 0 ? "" : _carouselClass, _width = param.width, width = _width === void 0 ? "fixed" : _width, _overwriteMoreLabel = param.overwriteMoreLabel, overwriteMoreLabel = _overwriteMoreLabel === void 0 ? false : _overwriteMoreLabel, _showControls = param.showControls, showControls = _showControls === void 0 ? true : _showControls, _triggerScrollUpdate = param.triggerScrollUpdate, triggerScrollUpdate = _triggerScrollUpdate === void 0 ? false : _triggerScrollUpdate, _showMoreButton = param.showMoreButton, showMoreButton = _showMoreButton === void 0 ? true : _showMoreButton;
    var ref = (0,dist/* default */.Z)(), scrollContainerRef = ref.scrollContainerRef, handleScroll = ref.handleScroll, scrollTo = ref.scrollTo, isAtStart = ref.isAtStart, isAtEnd = ref.isAtEnd;
    (0,react.useEffect)(function() {
        window.addEventListener("resize", handleScroll);
        return function() {
            return window.removeEventListener("resize", handleScroll);
        };
    }, [
        handleScroll
    ]);
    (0,react.useEffect)(function() {
        // "jolts" slider to recalculate end and start boolean values
        var refresh = function() {
            return scrollTo(-100);
        };
        var scrollElement = scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current;
        scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.addEventListener("load", refresh);
        return function() {
            return scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.removeEventListener("load", refresh);
        };
    }, [
        handleScroll,
        scrollContainerRef,
        scrollTo
    ]);
    (0,react.useEffect)(function() {
        handleScroll();
    }, [
        triggerScrollUpdate,
        handleScroll
    ]);
    var onBrandsMoreClick = function() {
        esm/* default.show */.ZP.show(BrandsModal);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "section-".concat(sectionName, " ").concat((carousel_module_default()).container, " ").concat(className),
        "data-width": width,
        "data-section-name": sectionName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((carousel_module_default()).top, " ").concat(!header ? (carousel_module_default())["no-header"] : ""),
                children: [
                    header && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (carousel_module_default()).title,
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "buttons ".concat((carousel_module_default())["button-group"]),
                        children: [
                            showMoreButton && (sectionName === "brands" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                onClick: onBrandsMoreClick,
                                hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                size: system/* Size.Small */.$u.Small,
                                label: "More"
                            }) : sectionName === "snaps" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                onClick: onCustomButtonClick,
                                hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                size: system/* Size.Small */.$u.Small,
                                label: "I'm not interested"
                            }) : moreLink && moreLabel && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* InternalLink */.h, {
                                href: moreLink,
                                hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                size: system/* Size.Small */.$u.Small,
                                hasPadding: true,
                                hasBackground: true,
                                children: [
                                    overwriteMoreLabel ? moreLabel : "More",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "sr-only",
                                        children: [
                                            " ",
                                            moreLabel
                                        ]
                                    })
                                ]
                            })),
                            showControls && !(isAtStart && isAtEnd) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (carousel_module_default()).controls,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((carousel_module_default())["button-left"], " ").concat(isAtStart ? (carousel_module_default()).disabled : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            icon: "ChevronLeft",
                                            hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                            size: system/* Size.Small */.$u.Small,
                                            onClick: function() {
                                                return scrollTo(-scrollValue);
                                            },
                                            disabled: isAtStart
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((carousel_module_default())["button-right"], " ").concat(isAtEnd ? (carousel_module_default()).disabled : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            icon: "ChevronRight",
                                            hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                            size: system/* Size.Small */.$u.Small,
                                            onClick: function() {
                                                return scrollTo(scrollValue);
                                            },
                                            disabled: isAtEnd
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((carousel_module_default()).carousel, " ").concat(carouselClass),
                onScroll: handleScroll,
                ref: scrollContainerRef,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Carousel/index.ts



/***/ }),

/***/ 56244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Icon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/lucide-react.js
var lucide_react = __webpack_require__(14358);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/Icon/Icon.tsx



var Icon = function(param) {
    var name = param.name, size = param.size, customClass = param.customClass;
    var ChosenIcon = lucide_react[name];
    var calculatedSize = 16;
    if (size === system/* Size.ExtraSmall */.$u.ExtraSmall) {
        calculatedSize = 10;
    }
    if (size === system/* Size.Medium */.$u.Medium) {
        calculatedSize = 20;
    }
    if (size === system/* Size.Large */.$u.Large) {
        calculatedSize = 24;
    }
    if (size === system/* Size.ExtraLarge */.$u.ExtraLarge) {
        calculatedSize = 28;
    }
    if (size === system/* Size.ExtraExtraLarge */.$u.ExtraExtraLarge) {
        calculatedSize = 40;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChosenIcon, {
        className: customClass ? customClass : "",
        size: calculatedSize
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Icon/index.ts



/***/ }),

/***/ 12914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SearchPills; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/views/SearchPills/search-pills.module.scss
var search_pills_module = __webpack_require__(87239);
var search_pills_module_default = /*#__PURE__*/__webpack_require__.n(search_pills_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Carousel/index.ts + 1 modules
var Carousel = __webpack_require__(46118);
// EXTERNAL MODULE: ./components/styleguide/Icon/index.ts + 1 modules
var Icon = __webpack_require__(56244);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/hooks/useExperiment.ts
var useExperiment = __webpack_require__(46389);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./store/reducers/search.js + 1 modules
var search = __webpack_require__(29109);
// EXTERNAL MODULE: ./store/selectors/search.js
var selectors_search = __webpack_require__(29906);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/views/SearchPills/SearchPills.js
















var SearchPills = function(param) {
    var _hasPadding = param.hasPadding, hasPadding = _hasPadding === void 0 ? true : _hasPadding;
    var usePrevious = function usePrevious(value) {
        var ref = (0,react.useRef)();
        (0,react.useEffect)(function() {
            ref.current = value;
        });
        return ref.current;
    };
    var ref = (0,react.useState)(0), activePillsLength = ref[0], setActivePillsLength = ref[1];
    var startPoint = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(null), scrollValue = ref1[0], setScrollValue = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useExperiment/* useExperiment */.a)(), 1), experimentGroup = ref2[0];
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var availableVehicleTags = (0,es/* useSelector */.v9)(selectors_search/* selectAvailableVehicleTags */.cW);
    var prevCount = usePrevious(availableVehicleTags);
    var activeVehicleTags = (0,es/* useSelector */.v9)(selectors_search/* selectActiveVehicleTags */.aV);
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var updateScrollValue = function() {
            if (startPoint.current) {
                setScrollValue(startPoint.current.offsetWidth);
            }
        };
        updateScrollValue();
        window.addEventListener("resize", updateScrollValue);
        return function() {
            return window.removeEventListener("resize", updateScrollValue);
        };
    }, [
        startPoint
    ]);
    (0,react.useEffect)(function() {
        if (startPoint && startPoint.current) {
            setScrollValue(startPoint.current.offsetWidth);
        }
        var active = activeVehicleTags.length;
        setActivePillsLength(active);
    }, [
        availableVehicleTags,
        activeVehicleTags,
        prevCount
    ]);
    var onPillClick = function(filter, value) {
        setIsLoading(true);
        if (startPoint && startPoint.current) {
            startPoint.current.scrollLeft = 0;
        }
        if (filter === constants/* FILTER_VEHICLE_TAGS */.cC) {
            (0,vehicle/* addToDataLayer */.Bk)({
                event: "search-pill",
                action: "".concat(activeVehicleTags.includes(value) ? "removed" : "added"),
                label: availableVehicleTags.filter(function(tag) {
                    return tag.id === value;
                })[0].name,
                experimentGroup: experimentGroup
            });
        }
        dispatch((0,search/* storeSearchMultiParameters */.Bn)({
            filter: filter,
            value: value
        }));
        setIsLoading(false);
    };
    var onClearPillsClick = function() {
        setIsLoading(true);
        if (startPoint && startPoint.current) {
            startPoint.current.scrollLeft = 0;
        }
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "search-pill",
            action: "clear-all",
            experimentGroup: experimentGroup
        });
        dispatch((0,search/* clearSelectedSearchFilter */.EA)(constants/* FILTER_VEHICLE_TAGS */.cC));
        setIsLoading(false);
    };
    if (availableVehicleTags.length === 0) {
        return false;
    }
    var getPills = function() {
        var pills = availableVehicleTags;
        if (pills.length === 0) {
            return [];
        }
        return (0,_to_consumable_array/* default */.Z)(pills).sort(function(a, b) {
            return [
                5,
                6,
                7,
                10,
                11,
                12
            ].includes(b.id) - [
                5,
                6,
                7,
                10,
                11,
                12
            ].includes(a.id);
        }).map(function(tag) {
            return {
                chipId: tag.id,
                chipType: Button/* ButtonHierarchy.ChipFilter */.B.ChipFilter,
                label: tag.name,
                disabled: isLoading
            };
        });
    };
    var renderPills = function(items) {
        var PillComponent = function(pill) {
            var isSelected = activeVehicleTags.includes(pill.chipId);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: function() {
                    return onPillClick(constants/* FILTER_VEHICLE_TAGS */.cC, pill.chipId);
                },
                type: "button",
                "data-chip-id": pill.chipId,
                className: (search_pills_module_default()).chip,
                "data-is-selected": isSelected,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (search_pills_module_default())["image-wrapper"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (search_pills_module_default()).rect
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "".concat((search_pills_module_default()).image, " ").concat([
                                    5,
                                    6,
                                    7
                                ].includes(pill.chipId) ? (search_pills_module_default()).bespoke : ""),
                                children: [
                                    5,
                                    6,
                                    7
                                ].includes(pill.chipId) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: (search_pills_module_default())["bespoke-chip"],
                                    alt: pill.label,
                                    src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/vehicle-tag-vehicles/").concat(pill.chipId, ".svg"),
                                    width: 504,
                                    height: 336
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "".concat(pill.label, " vehicle"),
                                    src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/vehicle-tag-vehicles/").concat(pill.chipId, ".png"),
                                    width: 504,
                                    height: 336
                                })
                            }),
                            isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (search_pills_module_default()).check,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon["default"], {
                                    name: "Check",
                                    size: system/* Size.ExtraSmall */.$u.ExtraSmall
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (search_pills_module_default()).label,
                        children: pill.label
                    })
                ]
            }, pill.chipId);
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                items.filter(function(i) {
                    return activeVehicleTags.includes(i.chipId) || [
                        5,
                        6,
                        7,
                        10,
                        11,
                        12
                    ].includes(i.chipId);
                }).sort(function(a, b) {
                    return activeVehicleTags.includes(b.chipId) - activeVehicleTags.includes(a.chipId);
                }).map(PillComponent),
                items.filter(function(i) {
                    return !activeVehicleTags.includes(i.chipId) && ![
                        5,
                        6,
                        7,
                        10,
                        11,
                        12
                    ].includes(i.chipId);
                }).sort(function(a, b) {
                    return a.chipId - b.chipId;
                }).map(PillComponent)
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        scrollValue: scrollValue,
        sectionName: "search-pills",
        triggerScrollUpdate: setIsLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (search_pills_module_default())["pill-wrapper"],
            "data-has-padding": hasPadding,
            ref: startPoint,
            children: [
                renderPills(getPills()),
                activePillsLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: (search_pills_module_default())["text-link"],
                    onClick: onClearPillsClick,
                    children: "Clear all"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/views/SearchPills/index.js



/***/ }),

/***/ 67227:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"carousel_container__QBa3N","carousel":"carousel_carousel___HIyX","top":"carousel_top__Ejz_R","button-group":"carousel_button-group__KuHj8","controls":"carousel_controls__l6IQd","button-left":"carousel_button-left__dzsFP","button-right":"carousel_button-right__mxuOU","disabled":"carousel_disabled__DhoqA","no-header":"carousel_no-header__qLh0q","phAnimation":"carousel_phAnimation__PK7Jm"};

/***/ }),

/***/ 87239:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pill-wrapper":"search-pills_pill-wrapper__QaZLO","chip":"search-pills_chip__y_5f3","label":"search-pills_label__nVWdK","rect":"search-pills_rect__vvtQ7","image-wrapper":"search-pills_image-wrapper__XdFfL","check":"search-pills_check__dX16h","image":"search-pills_image__cMFor","bespoke":"search-pills_bespoke__r_O_f","pills":"search-pills_pills__pFhfl","text-link":"search-pills_text-link__6lSvi","phAnimation":"search-pills_phAnimation__Z3z4i"};

/***/ }),

/***/ 36319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
function ___$insertStyle(e){if(e&&"undefined"!=typeof window){var t=document.createElement("style");return t.setAttribute("type","text/css"),t.innerHTML=e,document.head.appendChild(t),e}}__webpack_unused_export__ = ({value:!0});var react=__webpack_require__(67294),useSmoothHorizontalScroll=function(){var l=react.useRef(null),e=react.useState(!0),t=e[0],n=e[1],r=react.useState(!1),o=r[0],c=r[1];react.useEffect(function(){l.current&&c(l.current.scrollWidth===l.current.offsetWidth)},[l]);return{scrollContainerRef:l,handleScroll:function(){var e,t,r,o;l.current&&(n(0===(null===(e=l.current)||void 0===e?void 0:e.scrollLeft)),c(Math.floor((null===(t=l.current)||void 0===t?void 0:t.scrollWidth)-(null===(r=l.current)||void 0===r?void 0:r.scrollLeft))<=(null===(o=l.current)||void 0===o?void 0:o.offsetWidth)))},scrollTo:function(e){var t,r;null!==(t=l.current)&&void 0!==t&&t.scrollTo({left:(null===(r=l.current)||void 0===r?void 0:r.scrollLeft)+e,behavior:"smooth"})},isAtStart:t,isAtEnd:o}};exports.Z=useSmoothHorizontalScroll;
//# sourceMappingURL=index.js.map


/***/ })

}]);